<script setup lang="ts">
const { locale } = await useInitApp()
</script>

<template>
  <UApp :locale="locale">
    <NuxtLoadingIndicator />
    <ApplicationHeaderNavigation />
    <UMain>
      <NuxtPage />
    </UMain>
    <ApplicationFooter />
  </UApp>
</template>
